module.exports = __webpack_public_path__ + "img/no_history.1154929a.png";